import { createFileRoute } from "@tanstack/react-router";
import { PostDetailPage } from "@/features/study-group-stream/components/PostDetailPage";

export const Route = createFileRoute("/study-group/$study-group-id/post/$post-id")({
  component: PostDetailPage,
});
